import styled from 'styled-components';
import { goToPFGT } from '../../../utils';
import { infoStore } from '../../../store/infoStore';
import { TicketWithUsedButton } from '../../ticket/TicketWithUsedButton';
import { NumberTicket } from '../../ticket/NumberTicket';

export const MainEvent = ({ goOfflineTab }: { goOfflineTab: () => void }) => {
  const { info } = infoStore();

  return (
    <>
      <ImgContainer>
        <WelcomeText>메인 이벤트 참가 티켓 획득을 축하합니다!</WelcomeText>
      </ImgContainer>
      <BottomInfoContainer>
        {info.ticketNo &&
          info.ticketNo.map((cnt) => {
            if (info.ticketUseYn === 'Y')
              return <TicketWithUsedButton key={cnt.ticketNo} ticketNumber={cnt.ticketNo} />;

            return <NumberTicket key={cnt.ticketNo} cnt={cnt.ticketNo} />;
          })}

        <TicketDetailContainer>
          <TicketDetailText>
            PFGT 바로 가기 버튼을 클릭 후 선수 등록을 진행해주세요.
          </TicketDetailText>
          <TicketDetailText>토너먼트 참가 안내에서 상세 일정을 확인해주세요.</TicketDetailText>
        </TicketDetailContainer>
      </BottomInfoContainer>

      <BottomTabContainer>
        <GoOfflineEventDetailBtn onClick={goOfflineTab}>
          오프라인 이벤트
          <br /> 참가안내
        </GoOfflineEventDetailBtn>
        <GoPfgtBtn onClick={goToPFGT}>PFGT 바로가기</GoPfgtBtn>
      </BottomTabContainer>
    </>
  );
};

const WelcomeText = styled.h4`
  font-family: 'Gmarket';
  font-weight: 500;
  letter-spacing: -0.06em;
  color: #ff408c;
  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);

  font-size: 21px;
  line-height: 26px;
`;

const ImgContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 13px;
  margin-bottom: 15px;
  padding-left: 20px;
  padding-right: 20px;
`;

const BottomInfoContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  padding-left: 20px;
  padding-right: 20px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  padding-bottom: 130px;
`;

const BottomTabContainer = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 10;
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(90deg, rgba(25, 36, 255, 0.85) 39.5%, rgba(77, 14, 166, 0.85) 100%);

  backdrop-filter: blur(25px);
`;

const GoOfflineEventDetailBtn = styled.button`
  height: 100%;
  left: 0%;
  width: 100%;
  height: 70px;

  font-weight: 700;
  font-size: 21px;
  line-height: 24px;
  letter-spacing: -0.04em;

  color: #ffffff;

  background: rgba(0, 58, 146, 0.85);
`;

const GoPfgtBtn = styled.button`
  height: 100%;
  left: 0%;
  width: 100%;
  height: 70px;

  font-weight: 700;
  font-size: 21px;
  line-height: 24px;
  letter-spacing: -0.04em;

  color: #ffffff;
  background: rgba(133, 0, 154, 0.85);
`;

const TicketDetailContainer = styled.ul`
  padding-left: 10px;
  margin: 0;
  margin-top: 10px;
`;

const TicketDetailText = styled.li`
  font-weight: 500;
  letter-spacing: -0.04em;

  color: #939393;

  font-size: 16px;
  line-height: 24px;
`;
